<template>
	<div class="full">
		<vxe-grid ref="inputinvoicematchinventoryTable" v-if="list_gridOptions" v-bind="list_gridOptions"
			@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
		<purchasestockbill ref="precreateorder" :invoicedata="invoicedata"
			:invoicedetailgroupdata="invoicedetailgroupdata" :store="store" />
		<preinvoicesuggestion ref="preinvoicesuggestion" :invoicedata="invoicedata"
			:invoicedetailgroupdata="invoicedetailgroupdata" :store="store" />
			
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import purchasestockbill from './purchasestockbill/index.vue'
	import preinvoicesuggestion from './preinvoicesuggestion/index.vue'

	export default {
		mixins: [listMixins],
		props: {
			invoicedata: {
				default: () => {
					return {}
				}
			},
			store: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				inventory: [],
				invoicedetailgroupdata: [],
				outputinventoryName:[],
				list_footerField: [{
					field: 'price',
					toFixed: 4
				}]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			let outputinventoryName = this.store.inventoryreport.map((item)=>{
				return item.inventoryName
			})
			this.outputinventoryName = [...new Set(outputinventoryName)]
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				let selectoptions = this.store.inventory.map((item) => {
					return item.name
				})
				this.inventory = [...new Set(selectoptions)]
				gridOptions.toolbarConfig.buttons = [{
					name: '自动匹配',
					status: 'success',
					code: 'match'
				}, {
					name: '预计出库成本余额',
					status: 'primary',
					code: 'preinvoicesuggestion'
				}, {
					name: '预入库微调',
					status: 'danger',
					code: 'precreateorder'
				}]
				gridOptions.columns = [{
						type: 'checkbox',
						title: '#',
						width: 50
					}, {
						field: 'cargoName',
						title: '项目名称',
					},
					{
						field: 'amount',
						title: '数量',
					},
					{
						field: 'unitPrice',
						title: '单价',
					},
					{
						field: 'price',
						title: '金额',
					},
					{
						field: 'nazhi_inventoryname',
						title: '存货名称',
						sortable:true,
						editRender: {
							name: "$select",
							props: {
								selectoptions: this.inventory.map((item) => {
									return {
										value: item,
										label: item
									}
								})
							}
						},

					},
					{
						field: 'issell',
						title: '命中销项',	
						slots:{
							default:({row})=>{
								if(this.outputinventoryName.includes(row.nazhi_inventoryname)){
									return <span style="color:#67C23A">是</span>
								}else{
									return <span style="color:#F56C6C">否</span>
								}
							}
						}
					},
					// {
					// 	title: '操作',
					// 	fixed: "right",
					// 	align: 'center',
					// 	width: 65,
					// 	slots: {
					// 		default: ({row}) => {
					// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.ddcode(row)}}>凭证</el-button>]
					// 		}
					// 	}
					// }
				]
				gridOptions.formConfig = false
				gridOptions.pagerConfig.enabled = false
				gridOptions.editRules = {
					"nazhi_inventoryname": [{
						required: true
					}]
				}
			},
			list() {
				return new Promise((resolve) => {
					this.$api.invoice.getinputinvoicedetail({
						invoiceId: this.invoicedata.invoiceId,
						action: 'matchinventory'
					}).then((res) => {
						resolve({
							list: res
						})
					})
					// let groupdata = this.$Lodash.groupBy(this.data, 'bankAcc')
					// for(let i in groupdata){
					// 	let obj = {}
					// 	obj.id = groupdata[i][0].id
					// 	obj.bankAcc = i
					// 	obj.accName = groupdata[i][0].accName
					// 	obj.needamount = this.$Lodash.sumBy(groupdata[i], item=>parseFloat(item.needamount))
					// 	obj.needamount = obj.needamount.toFixed(2)
					// 	data.push(obj)
					// }
					// console.log(data)

				})
			},
			match() {
				let data = this.$refs.inputinvoicematchinventoryTable.getCheckboxRecords()
				if (!data.length) {
					this.$message.error('请选择数据')
					return false
				}
				data.forEach((item) => {
					item.nazhi_inventoryname = null
					let cargoNameArr = item.cargoName.split(/\*+/).filter(item => item !== "")
					this.inventory.forEach((_item) => {						
						let inventoryArr = _item.split(/\*+/).filter(_item => _item !== "")
						if ((cargoNameArr.length == inventoryArr.length) && cargoNameArr.length == 2) {							
							if (cargoNameArr[0] == inventoryArr[0] && cargoNameArr[1].includes(
									inventoryArr[1]) ) {
								item.nazhi_inventoryname = _item
							}
						}
					})
				})
				this.$refs.inputinvoicematchinventoryTable.reloadData(data)
			},
			preinvoicesuggestion(){
				let data = this.$refs.inputinvoicematchinventoryTable.getTableData().fullData
				let buff = true
				data.forEach((item) => {
					if (!item.nazhi_inventoryname) {
						buff = false
					}
				})
				if (!buff) {
					this.$message.error('存货名称未填写')
					return
				}				
				this.$api.invoice.inputinvoicedetailmatchinventorysave({
					data: data,
				}).then(() => {
					let invoicedetailgroupdata = this.$Lodash.groupBy(data, 'nazhi_inventoryname')
					invoicedetailgroupdata = JSON.parse(JSON.stringify(invoicedetailgroupdata))
					for (let i in invoicedetailgroupdata) {
						let amount = this.$Lodash.sumBy(invoicedetailgroupdata[i], (item) => {
							return parseFloat(item.amount)
						})
						let price = this.$Lodash.sumBy(invoicedetailgroupdata[i], (item) => {
							return parseFloat(item.price)
						})
						invoicedetailgroupdata[i] = invoicedetailgroupdata[i][0]
						invoicedetailgroupdata[i].amount = amount.toFixed(4)
						invoicedetailgroupdata[i].price = price.toFixed(4)
						invoicedetailgroupdata[i].unitPrice = (price / amount).toFixed(4)
					}
					this.invoicedetailgroupdata = invoicedetailgroupdata
					this.$refs.preinvoicesuggestion.modal_show()
				})
			},
			precreateorder() {
				let data = this.$refs.inputinvoicematchinventoryTable.getTableData().fullData
				let buff = true
				data.forEach((item) => {
					if (!item.nazhi_inventoryname) {
						buff = false
					}
				})
				if (!buff) {
					this.$message.error('存货名称未填写')
					return
				}

				this.$api.invoice.inputinvoicedetailmatchinventorysave({
					data: data,
				}).then(() => {
					let invoicedetailgroupdata = this.$Lodash.groupBy(data, 'nazhi_inventoryname')
					invoicedetailgroupdata = JSON.parse(JSON.stringify(invoicedetailgroupdata))
					for (let i in invoicedetailgroupdata) {
						let amount = this.$Lodash.sumBy(invoicedetailgroupdata[i], (item) => {
							return parseFloat(item.amount)
						})
						let price = this.$Lodash.sumBy(invoicedetailgroupdata[i], (item) => {
							return parseFloat(item.price)
						})
						invoicedetailgroupdata[i] = invoicedetailgroupdata[i][0]
						invoicedetailgroupdata[i].amount = amount.toFixed(4)
						invoicedetailgroupdata[i].price = price.toFixed(4)
						invoicedetailgroupdata[i].unitPrice = (price / amount).toFixed(4)
					}
					this.invoicedetailgroupdata = invoicedetailgroupdata
					this.$refs.precreateorder.modal_show()
				})
			},
			customreload(){
				this.$refs.inputinvoicematchinventoryTable.commitProxy('query')
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			purchasestockbill,
			preinvoicesuggestion
		}
	}
</script>